import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { EnterOTP } from './otpVerify/otp.component';
import { IndexComponent } from './index/index.component';
import { ClaimReward } from './claimReward/claimReward';
import { from } from 'rxjs/observable/from';
import { ThankYou } from './thankYou/thankYou';

export const routes: Routes = [
    {
        path: '',
        component: IndexComponent,
        pathMatch: 'full',
    },
    {
        path: 'otpVerify',
        component: EnterOTP
    },
    {
        path: 'claimReward',
        component: ClaimReward
    },
    {
        path: 'thankYou',
        component: ThankYou
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts